import { render, staticRenderFns } from "./SalesClientBrand.vue?vue&type=template&id=5833faee"
import script from "./SalesClientBrand.vue?vue&type=script&lang=js"
export * from "./SalesClientBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports